import EventEmitter from 'eventemitter3';

export type EnquiryModalProps = {
    supplier: {
        id: number,
        name: string,
        regionId: number,
        region?: string,
        state?: string,
        category?: string,
    },
    category: {
        id: number,
        slug: string,
    },
    source: string,
    onCompleted?: () => void,
};

interface EnquiryFormEvents {
    open: EnquiryModalProps
    contacted: { supplierId: number, categoryId: number, categorySlug: string, supplierRegionId: number }
    close: undefined,
}
export const enquiryFormEventEmitter = new EventEmitter<EnquiryFormEvents>();

export const openEnquiryFormModal = (props: EnquiryModalProps) => {
    enquiryFormEventEmitter.emit('open', props);
}
export const enquirySent = (supplierId: number, categoryId: number, categorySlug: string, supplierRegionId: number) => {
    enquiryFormEventEmitter.emit('contacted', { supplierId, categoryId, categorySlug, supplierRegionId });
}
export const closeFlyout = () => {
    enquiryFormEventEmitter.emit('close', undefined);
}